import React, { useEffect, useState } from "react";
import { Modal, ModalContent, ModalOverlay, ModalHeader, useDisclosure } from "@chakra-ui/react";
import image from "../../images/newsletter.jpeg?format=webp&w=720&h=256"

export function SectionCta() 
{
    const [hasSeenWelcomeModal, setHasSeenWelcomeModal] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isWelcomeOpen, onOpen: onWelcomeOpen, onClose: onWelcomeClose } = useDisclosure();

    useEffect(() => 
    {
        const script = document.createElement('script');
        script.src = "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js";
        script.async = true;
        document.body.appendChild(script);

        // Check if user has seen the welcome modal
        const hasSeenModal = localStorage.getItem('hasSeenWelcomeModal');
        if (!hasSeenModal) {
            onWelcomeOpen();
            localStorage.setItem('hasSeenWelcomeModal', 'true');
        }

        return () => 
        {
            document.body.removeChild(script);
        }
    }, []);

    // Handler to open newsletter modal and close welcome modal
    const handleSignUpClick = () => {
        onOpen();
        onWelcomeClose();
    };

    return (
        <section id="signUpBanner" className="section-cta"> 
            {/* Welcome Modal */}
            <Modal isOpen={isWelcomeOpen} onClose={onWelcomeClose} size="xl">
                <ModalOverlay />
                <ModalContent className="p-0 rounded-lg overflow-hidden mx-2.5 isWelcomeOpen-section" style={{ backgroundColor: 'transparent !important' }}>
                    <div className="sr-only">
                        <ModalHeader>Subscribe now to our monthly newsletter.</ModalHeader> 
                    </div>
                    <div className="flex flex-col md:flex-row isWelcomeOpen-div">
                        {/* Left side: Image and text */}
                        <div className="flex-1 bg-cover flex bg-center flex-col items-start p-5 md:p-10 relative" style={{
                            backgroundImage: `url('${image}')`,
                          }}>
                            <div className="z-10 text-shadow-md">
                                <p style={{ color: '#fff', fontSize: '1.2rem', fontWeight: 400, marginBottom: '1rem', letterSpacing: '1px' }}>IMPACT UNLOCKED.</p>
                                <h2 style={{ color: '#fff', fontSize: '2.2rem', fontWeight: 700, lineHeight: 1.1, marginBottom: 0 }}>
                                    Sharp analysis.<br />
                                    Lasting solutions.
                                </h2>
                                <div style={{ borderBottom: '2px solid #fff', margin: '1.2rem 0' }} />
                            </div>
                            <div className="absolute top-0 w-full left-0 h-full opacity-60 md:opacity-20 bg-black"></div>
                        </div>
                        {/* Right side: Green background and button */}
                        <div className="p-5 md:p-10" style={{
                            flex: 1,
                            background: '#7BB13D',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}>
                            <h3 className="h3" style={{ color: '#fff', fontWeight: 700, marginBottom: '2.5rem' }}>
                              Subscribe now to our monthly newsletter.
                            </h3>
                            <button onClick={handleSignUpClick} className="btn btn--black js-form-open w-max">Sign up</button>
                        </div>
                    </div>
                </ModalContent>
            </Modal>

            <div className="hidden md:block" style={{
                backgroundImage: `url('${image}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100%",
            }}>
            </div>

            <div className="shell">
                <p className="section__title h2 border-b-3 w-max text-shadow-md">IMPACT UNLOCKED.</p>
                <p className="section__subtitle h3">Subscribe now to our monthly newsletter.</p>
                <button onClick={onOpen} className="btn btn--black js-form-open">Sign up</button>
                <Modal isOpen={isOpen} onClose={onClose} size="2xl" >
                    <ModalOverlay />
                        <ModalContent>
                              <div
                                className="l-form-default"
                                style={{
                                  padding: "2rem",
                                  background: "#EEEEEE"
                                }}
                              >
                                <div>
                                  <div className="l-center-container">
                                    <div className="sc-ckVGcZ jslhpj">
                                      <h1 className="sc-jKJlTe jmtkzV">
                                        Sign up to the Genesis newsletter
                                      </h1>
                                    </div>
                                    <div>
                                      <div className="sc-bdVaJa iIDDUy">
                                        <div>
                                          <p className="sc-Rmtcm hRybD" />
                                          <div spacing="base" className="sc-iAyFgw kFBOaz" />
                                        </div>
                                        <form
                                          className="js-cm-form"
                                          id="subForm"
                                          action="https://www.createsend.com/t/subscribeerror?description="
                                          method="post"
                                          data-id="191722FC90141D02184CB1B62AB3DC26BBD973F061F4F2D75786D34499396E3E386E18D58B4C86830372D975D5B48D0E1D74B72B9504A89F6E1FAA835ADF7BD1"
                                        >
                                          <div className="sc-cSHVUG jZSLFe">
                                            <div className="sc-cSHVUG kXIIFK">
                                              <div>
                                                <label htmlFor="fieldName" className="sc-gzVnrw hYNtOw">
                                                  Name <span className="sc-dnqmqq iFTUZ">*</span>
                                                </label>
                                                <input
                                                  id="fieldName"
                                                  maxLength={200}
                                                  name="cm-name"
                                                  placeholder="Your name"
                                                  required=""
                                                  className="sc-gZMcBi dshyOS"
                                                />
                                              </div>
                                            </div>
                                            <div className="sc-cSHVUG kXIIFK">
                                              <div>
                                                <label htmlFor="fieldEmail" className="sc-gzVnrw cKFCFj">
                                                  Email <span className="sc-dnqmqq iFTUZ">*</span>
                                                </label>
                                                <input
                                                  autoComplete="Email"
                                                  id="fieldEmail"
                                                  maxLength={200}
                                                  name="cm-tjfurr-tjfurr"
                                                  placeholder="Your email"
                                                  required=""
                                                  type="email"
                                                  className="js-cm-email-input qa-input-email sc-gZMcBi dshyOS"
                                                />
                                              </div>
                                            </div>
                                            <div>
                                              <label className="sc-gzVnrw hSefwP">
                                                Opt in to another list
                                              </label>
                                              <div>
                                                <div className="sc-bwzfXH ebeRtN">
                                                  <input
                                                    id="ehdhjr"
                                                    name="cm-ol-ehdhjr"
                                                    type="checkbox"
                                                    defaultValue="ehdhjr"
                                                    className="qa-checkbox-cm-ol-ehdhjr sc-bZQynM eKOoKL"
                                                  />
                                                  <label htmlFor="ehdhjr" className="sc-bxivhb fiUAra">
                                                    Competition &amp; Regulation News{" "}
                                                  </label>
                                                  <div
                                                    id="ehdhjr-required-label"
                                                    hidden=""
                                                    className="sc-EHOje jMsntP"
                                                  >
                                                    *
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                <div className="sc-bwzfXH ebeRtN">
                                                  <input
                                                    id="edldtd"
                                                    name="cm-ol-edldtd"
                                                    type="checkbox"
                                                    defaultValue="edldtd"
                                                    className="qa-checkbox-cm-ol-edldtd sc-bZQynM eKOoKL"
                                                  />
                                                  <label htmlFor="edldtd" className="sc-bxivhb fiUAra">
                                                    Development News
                                                  </label>
                                                  <div
                                                    id="edldtd-required-label"
                                                    hidden=""
                                                    className="sc-EHOje jMsntP"
                                                  >
                                                    *
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                <div className="sc-bwzfXH ebeRtN">
                                                  <input
                                                    id="edlhhu"
                                                    name="cm-ol-edlhhu"
                                                    type="checkbox"
                                                    defaultValue="edlhhu"
                                                    className="qa-checkbox-cm-ol-edlhhu sc-bZQynM eKOoKL"
                                                  />
                                                  <label htmlFor="edlhhu" className="sc-bxivhb fiUAra">
                                                    Financial Services News
                                                  </label>
                                                  <div
                                                    id="edlhhu-required-label"
                                                    hidden=""
                                                    className="sc-EHOje jMsntP"
                                                  >
                                                    *
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                <div className="sc-bwzfXH ebeRtN">
                                                  <input
                                                    id="edlhtr"
                                                    name="cm-ol-edlhtr"
                                                    type="checkbox"
                                                    defaultValue="edlhtr"
                                                    className="qa-checkbox-cm-ol-edlhtr sc-bZQynM eKOoKL"
                                                  />
                                                  <label htmlFor="edlhtr" className="sc-bxivhb fiUAra">
                                                    Health News
                                                  </label>
                                                  <div
                                                    id="edlhtr-required-label"
                                                    hidden=""
                                                    className="sc-EHOje jMsntP"
                                                  >
                                                    *
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="sc-cSHVUG jZSLFe">
                                              <div>
                                                <div spacing="x-small" className="sc-iAyFgw coBuPy" />
                                                <div className="sc-cSHVUG jZSLFe">
                                                  <div>
                                                    <div>
                                                      <div className="sc-bwzfXH ebeRtN">
                                                        <input
                                                          aria-required=""
                                                          id="cm-privacy-consent"
                                                          name="cm-privacy-consent"
                                                          required=""
                                                          type="checkbox"
                                                          className="qa-checkbox-cm-privacy-consent sc-bZQynM eKOoKL"
                                                        />
                                                        <label
                                                          htmlFor="cm-privacy-consent"
                                                          className="sc-bxivhb fiUAra"
                                                        >
                                                          I agree to receive marketing material from Genesis
                                                          Analytics.
                                                        </label>
                                                        <div
                                                          id="cm-privacy-consent-required-label"
                                                          className="sc-EHOje jMsntP"
                                                        >
                                                          *
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <input
                                                      id="cm-privacy-consent-hidden"
                                                      name="cm-privacy-consent-hidden"
                                                      type="hidden"
                                                      defaultValue="true"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <button
                                            type="submit"
                                            className="js-cm-submit-button sc-brqgnP dwYSlG"
                                          >
                                            Subscribe
                                          </button>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '.iIDDUy { background: rgb(255, 255, 255); border-radius: 0.3125rem; max-width: 35.25rem; margin-left: auto; margin-right: auto; padding: 2.5rem 2.75rem; position: relative; }.fOEEVC { background: rgb(255, 255, 255); border-radius: 0.3125rem; max-width: 35.25rem; margin-left: auto; margin-right: auto; padding: 2.5rem 2.75rem; position: relative; }.ebeRtN { align-items: flex-start; display: flex; }.cUyRKv { font-size: 0.875rem; padding-left: 0.5rem; overflow-wrap: break-word; word-break: break-word; position: relative; top: 2px; }.fiUAra { font-size: 0.875rem; padding-left: 0.5rem; overflow-wrap: break-word; word-break: break-word; font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(67, 77, 93); position: relative; top: 2px; }.jMsntP { color: rgb(221, 54, 42); font-weight: 400; font-size: 0.75rem; margin-left: 0.125rem; }.eKOoKL { flex-shrink: 0; height: 1rem; position: relative; top: 0.08rem; width: 1rem; }.hYNtOw { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }.cKFCFj { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }.hSefwP { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }.iFTUZ { color: rgb(221, 54, 42); }.dshyOS { appearance: none; background-color: rgb(255, 255, 255); border: 0px; border-radius: 0.1875rem; box-sizing: border-box; box-shadow: rgba(142, 154, 173, 0.1) 0px 2px 0px 0px inset, rgb(210, 215, 223) 0px 0px 0px 1px inset, rgb(255, 255, 255) 0px 1px 0px 0px; color: rgb(67, 77, 93); font-size: 0.875rem; line-height: 1.5; min-height: 2.8125rem; outline: 0px; padding: 0.75rem 1rem; transition: box-shadow 0.2s; width: 100%; }.dshyOS:focus { box-shadow: transparent 0px 0px 0px 0px inset, rgb(80, 156, 246) 0px 0px 0px 1px inset, rgba(80, 156, 246, 0.25) 0px 0px 0px 2px; }.jZSLFe { margin-bottom: 1.5rem; }.kXIIFK { margin-bottom: 1rem; }.gIFfJb { margin-bottom: 0rem; }.jslhpj { margin-left: auto; margin-right: auto; max-width: 29.125rem; padding-bottom: 3.125rem; }.bdmseg { margin-left: auto; margin-right: auto; max-width: 29.125rem; padding-bottom: 0.5rem; }.jmtkzV { font-size: 3rem; text-align: center; letter-spacing: -1px; line-height: 1.17; -webkit-font-smoothing: antialiased; font-family: Lato, Arial, sans-serif; font-weight: 900; color: rgb(0, 0, 0); }.jCvNiK { font-size: 2em; margin: 0.67em 0px; font-weight: bold; color: rgb(0, 0, 0); }.kFBOaz { border-bottom: 1px solid rgb(210, 215, 223); margin-bottom: 1.5rem; padding-top: 1.5rem; }.coBuPy { border-bottom: 1px solid rgb(210, 215, 223); margin-bottom: 0.75rem; padding-top: 0.75rem; }.cVhqQi { margin-bottom: 0.25rem; }@-webkit-keyframes iECmZH {   0% { transform: rotate(0deg); }  100% { transform: rotate(360deg); }}@keyframes iECmZH {   0% { transform: rotate(0deg); }  100% { transform: rotate(360deg); }}.dwYSlG { background-color: rgb(123, 177, 61); border: none; border-radius: 3px; color: rgb(255, 255, 255); display: inline-block; font-family: Helvetica, Arial, sans-serif; font-weight: 400; font-size: 1rem; line-height: 1; outline: 0px; padding: 0.75rem 1.5rem; text-decoration: none; transition: background-color 0.1s ease-in, box-shadow 0.1s ease-in; }.dwYSlG:hover { cursor: pointer; }.eLWSFO { line-height: 0; max-height: 100%; max-width: 100%; pointer-events: none; height: 1rem; width: 1rem; }.hRybD { white-space: pre-wrap; font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(67, 77, 93); }a, abbr, address, article, aside, b, blockquote, body, caption, cite, code, dd, details, dialog, div, dl, dt, em, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, html, i, iframe, img, label, legend, li, main, menu, nav, object, ol, p, pre, section, small, span, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, u, ul { border: 0px; margin: 0px; padding: 0px; }*, ::after, ::before { box-sizing: inherit; }html { font-family: "Helvetica Neue", Arial, sans-serif; font-size: 16px; }h1, h2, h3, h4, h5, h6, html { color: rgb(67, 77, 93); font-weight: 400; line-height: 1.5; }a { color: rgb(25, 169, 229); text-decoration: underline; }button, label, p { overflow-wrap: break-word; word-break: break-word; }'
                                }}
                              />
                        </ModalContent>
                </Modal>
            </div>
        </section>
    );
}
